import { Avatar } from 'antd';
import AnyBodyImage from 'components/AnyBodyImage';
import Text from 'components/Text';
import { get } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import check_icon from './check.svg';
type IComponentProps = {
  selected?: boolean;
  name?: string;
  src?: string;
  onClick?: () => void;
  isBusy?: boolean;
  bgColor?: string;
  className?: string;
  boxShadow?: boolean;
  margin?: string;
  anybody?: boolean;
  cashier?: boolean;
};

const AvatarBox: React.FC<IComponentProps> = ({
  selected,
  name,
  src,
  onClick,
  isBusy, // just like disabled
  anybody,
  bgColor,
  boxShadow, // have border or not
  className = '',
  cashier = false,
}) => {
  const classNames = [
    className,
    isBusy && 'isBusy',
    selected && 'selected',
    boxShadow && 'boxShadow',
    cashier && 'cashier',
  ].filter(Boolean).join(' ');

  return (
    <AvatarTicketBoxStyled
      onClick={isBusy ? undefined : onClick}
      className={classNames}
      style={{ borderColor: bgColor }}
    >
      {selected && (
        <IconBadgeStyled>
          <img src={check_icon} alt='check_icon' style={{ width: 32, height: 32 }} />
        </IconBadgeStyled>
      )}
      {anybody ? <AnyBodyImage large /> : <Avatar className="circle-avatar" src={src}>
        {get(name, [0], '')}
      </Avatar>}
      <Text textAlign="center" variant="CONTENT_2" color="text_3">
        {name}
      </Text>
    </AvatarTicketBoxStyled>
  );
};

export default React.memo(AvatarBox);

const AvatarTicketBoxStyled = styled.div`
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  width: 5.5rem;
  min-height: 6.5rem;
  padding: 0.5rem 0.5rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border: 1px solid #ffffff;
  background: #ffffff;
  box-shadow: unset;

  &.selected {
    border-color: #C6E9EF;
    background: #C6E9EF;
    box-shadow: -1px 1px 4px 0px rgba(0, 0, 0, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }

  &.boxShadow {
    box-shadow: -1px 1px 4px 0px rgba(0, 0, 0, 0.10) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
      
  .circle-avatar {
    width: 5.5rem;
    min-height: 5.5rem;
    border-radius: 50%;
    font-size: 2rem;
    display: flex;
    align-items: center;
  }

  &.cashier {
    width: 8.1rem;
    .circle-avatar {
      width: 8rem;
      min-height: 8rem;
      border-radius: 50%;
      font-size: 2.5rem;
      display: flex;
      align-items: center;
    }
    .CONTENT_2 {
      margin-top: 4px;
      font-size: 22px;
    }
  }
  transition: all 0.3s ease;
  &:hover:not(.selected) {
    background: #F5F5F5;
    border-color: #C6E9EF;
    box-shadow: -1px 1px 4px 0px rgba(0, 0, 0, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
  &.isBusy {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const IconBadgeStyled = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: #2D6772;
  z-index: 2;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
`;
